import { queryGetUser } from "@type/api/user/getUser";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface UseGetProfileParams {
  userId?: string;
  lang?: string;
}

export const useGetProfile = ({ userId, lang }: UseGetProfileParams) => {
  const queryGetProfile = useQueryWithCallbacks({
    enabled: !!userId,
    queryKey: queryGetUser._key(userId, lang),
    queryFn: () => queryGetUser(userId, lang),
  });

  return {
    ...queryGetProfile,
  };
};
